import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL, BASE_API_V2_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioBookBySeriesPageApi = createApi({
  reducerPath: 'audioBookBySeriesPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_V2_URL ,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioBookBySeriesPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudiobookBySeriesData: builder.query({
      query: (option) => ({
        // url : 'book_by_series',
        url: '/audio/detail/v2',
        method: 'POST',
        body : {
            "item_id": option,
            "series_id": option,
            "phone": "",
            "platform": "Android",
            "udid": "",
            "user_id": getLocalStorageData(), //"959770179977"
            "version_code": 70,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudiobookBySeriesDataQuery, endpoints } = audioBookBySeriesPageApi;